import ErrorBannerNotificationEnum from '@models/enums/ErrorBannerNotificationEnum';
import create from 'zustand';

interface IErrorBannerNotificationState {
  readonly errorBannerNotification: ErrorBannerNotificationEnum | null;
  readonly setErrorBannerNotification: (
    errorNotificationDisplay: ErrorBannerNotificationEnum | null
  ) => void;
}

const useErrorNotificationStore = create<IErrorBannerNotificationState>(
  (set) => ({
    errorBannerNotification: null,
    setErrorBannerNotification: (
      errorBannerNotification: ErrorBannerNotificationEnum | null
    ) => set({ errorBannerNotification }),
  })
);

export default useErrorNotificationStore;
